/* ============================================================
   100% CAPRI — LINEN CONCIERGE SAFE COMPACT JS 4.2
   - Gender via metafield custom.gender
   - Automatic gender detection
   - Step engine
   - Scoring engine
   - Results render
   - Cinematic reveal + AI fade + Start Over
============================================================ */

var selections = { occasion_group:null, climate:null, mood:null, airiness:null };

function norm(v){ return typeof v==="string" ? v.toLowerCase().trim() : ""; }
function safeA(v){ return Array.isArray(v)?v:[]; }
function show(id){ var e=document.getElementById(id); if(e) e.classList.remove("lc-hidden"); }

/* Occasion rules */
var OccasionMap={
  relaxed_day:["daywear","capri day","vacation stroll","resort day"],
  beach_club:["beach club","poolside"],
  casual_evening:["casual dinner","casual evening","rooftop evening"],
  elegant_evening:["elegant evening","terrace cocktail","special dinner"],
  ceremony:["summer ceremony"],
  travel_city:["city summer","business meeting","travel"]
};

/* Mood → Fit */
var MoodFit={ Relaxed:"relaxed", Essential:"regular", Elegant:"slim" };

/* Airiness rules */
var Airiness={
  "Very Lightweight":{ t:[2,3], w:["light"] },
  "Light Medium":{ t:[1,2], w:["medium"] },
  "Structured":{ t:[1], w:["heavy","structured"] }
};

/* ============================================================
   SCORING ENGINE
============================================================ */

function score(p){
  var m=p.metafields||{}, s=selections, c=0;

  var occT = OccasionMap[s.occasion_group] || [];
  var occP = safeA(m.occasion).map(norm);
  occT.forEach(function(t){ if(occP.indexOf(norm(t))>-1) c+=2; });

  var cliP = safeA(m.climate).map(norm);
  if(cliP.indexOf(norm(s.climate))>-1) c+=2;

  var expected=MoodFit[s.mood];
  if(expected && m.fit && norm(m.fit)===expected) c+=1.5;

  var air=Airiness[s.airiness];
  if(air){
    var tr=parseInt(m.transparency_level);
    if(air.t.indexOf(tr)>-1) c+=1;
    if(air.w.indexOf(norm(m.fabric_weight))>-1) c+=1;
  }

  if(!m.occasion && !m.climate && !m.fit) c-=1;

  return c;
}

/* ============================================================
   CINEMATIC ANIMATION
============================================================ */

function revealCards(){
  setTimeout(function(){
    document.querySelectorAll(".lc-product-card,.lc-hero-product")
      .forEach(function(c){ c.classList.add("lc-show"); });
  },50);
}

/* ============================================================
   RENDER RESULTS
============================================================ */

function render(products){
  var h=document.getElementById("lc-results-hero"),
      g=document.getElementById("lc-results-grid");
  h.innerHTML=""; g.innerHTML="";

  var top=products[0];

  h.innerHTML=
    '<a href="/products/'+top.handle+'" class="lc-hero-product">'+
    '<img src="'+top.image+'" class="lc-hero-image">'+
    '<h3>'+top.title+'</h3><p>'+top.price+'</p></a>';

  products.slice(1,10).forEach(function(p){
    g.innerHTML+=
      '<div class="lc-product-card">'+
      '<a href="/products/'+p.handle+'">'+
      '<img src="'+p.image+'" class="lc-product-image">'+
      '<div>'+p.title+'</div><div>'+p.price+'</div>'+
      '</a></div>';
  });

  revealCards();
}

/* ============================================================
   STEP ENGINE
============================================================ */

function init(){
  var btns=document.querySelectorAll("[data-step]");
  if(!btns.length) return requestAnimationFrame(init);

  btns.forEach(function(b){
    b.addEventListener("click",function(){
      var step=b.dataset.step, val=b.dataset.value;
      selections[step]=val;

      b.parentElement.querySelectorAll("button")
        .forEach(function(x){ x.classList.remove("active"); });
      b.classList.add("active");

      if(step==="occasion_group") show("step-climate");
      if(step==="climate") show("step-mood");
      if(step==="mood") show("step-airiness");
      if(step==="airiness") document.getElementById("lc-show-results")
        .classList.remove("lc-hidden");
    });
  });
}
document.addEventListener("DOMContentLoaded",init);

/* ============================================================
   GENDER DETECTION (AUTO)
============================================================ */

function detectGender(list){
  var m = list.filter(p => p.gender==="male").length;
  var f = list.filter(p => p.gender==="female").length;
  if(f > m) return "female";
  if(m > f) return "male";
  return "unisex";
}

/* ============================================================
   SHOW RESULTS
============================================================ */

document.getElementById("lc-show-results").addEventListener("click",function(){

  var ai=document.getElementById("lc-ai-response");
  ai.classList.remove("lc-hidden");
  ai.classList.add("lc-visible");

  document.getElementById("lc-ai-text").innerText=
    "Your linen journey blends "+selections.mood.toLowerCase()+
    " elegance with comfort ideal for "+selections.climate.toLowerCase()+" climates.";

  var detected = detectGender(window.LinenProducts);

  var productsGendered = window.LinenProducts.filter(function(p){
    return p.gender===detected || p.gender==="unisex";
  });

  var products = productsGendered.map(function(p){
    p.score=score(p); return p;
  }).sort(function(a,b){ return b.score-a.score; });

  if(products.length<6) products = productsGendered.slice(0,12);

  document.getElementById("lc-results").classList.remove("lc-hidden");

  render(products);
  showStartOver();
});

/* ============================================================
   START OVER (Apple-style)
============================================================ */

function showStartOver(){
  var wrap=document.querySelector(".lc-start-over-wrapper"),
      btn=document.getElementById("lc-start-over");

  wrap.classList.remove("lc-hidden");
  wrap.classList.add("lc-visible");

  btn.addEventListener("click",function(){

    selections={ occasion_group:null, climate:null, mood:null, airiness:null };

    document.querySelectorAll("[data-step]")
      .forEach(function(x){ x.classList.remove("active"); });

    document.querySelectorAll(".lc-step")
      .forEach(function(s){ s.classList.add("lc-hidden"); });

    document.getElementById("step-occasion").classList.remove("lc-hidden");
    document.getElementById("lc-results").classList.add("lc-hidden");
    document.getElementById("lc-ai-response").classList.add("lc-hidden");

    wrap.classList.add("lc-hidden");
    window.scrollTo({ top:0, behavior:"smooth" });
  });
}
